import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection,
  AngularFirestoreDocument } from '@angular/fire/firestore';
import { Timestamp } from '@firebase/firestore';
import { FirestoreService } from './firestore.service';
import { SalesTableItem } from '../sales-table/sales-table-datasource';
//import * as firebase from 'firebase';

const EXAMPLE_DATA: SalesTableItem[] = [
  {name: 'Please Wait', email: 'Fetching Leads', phone: '', location: [''], agent: {}, updatedAt: new Date(), status: '', notes: ''}];


@Injectable({
  providedIn: 'root'
})
export class SalesLeadsService {

  dataObs: BehaviorSubject<SalesTableItem[]> = new BehaviorSubject<SalesTableItem[]>(EXAMPLE_DATA);
  leadsCollection: AngularFirestoreCollection;
  currentObs: Observable<any>;
  currentSub: Subscription;



  // broadcast = (snapshot) => {
  //   console.log("The observable has been triggered. snapshot is ", snapshot);
  //   let temp: SalesTableItem[] = [];
  //   console.log("The entire ", snapshot);
  //   snapshot.map((row)=> {
  //     temp.push({
  //     'name': row.name,
  //     'email' : row.email,
  //     'phone': row.phone,
  //     'location': row.locations,
  //     'updatedAt': row.updatedAt.toDate()
  //   })});
  //   this.dataObs.next(temp);
  // };

  constructor(private afs: AngularFirestore) {
    console.log("SAles Leads Service initiated");
    console.log("Firestore object is ", this.afs);
    this.leadsCollection = this.afs.collection('leads', ref => ref.orderBy('updatedAt', 'desc'));
    this.currentObs = this.leadsCollection.valueChanges();
    this.currentSub = this.currentObs.subscribe((snapshot) => {
      console.log("The observable has been triggered. snapshot is ", snapshot);
      let temp: SalesTableItem[] = [];
      snapshot.map((row)=> {
        temp.push({
        'name': row.name,
        'email' : row.email,
        'phone': row.phone,
        'location': row.locations,
        'notes': row.notes,
        'agent': {'name': row.agent.name , 'email': row.agent.email},
        'updatedAt': row.updatedAt.toDate(),
        'status': row.status
      })});
      this.dataObs.next(temp);
    });
  //  this.dataObs = new BehaviorSubject<SalesTableItem[]>(this.afs.);
  }


  public upload(files: File): {[key:string]:Observable<number>} {
    return;
  }

  getObs(){
    return this.dataObs;
  }


  markDead(row, reason){
    console.log("In function mark dead.");
    console.log("VAlue of the row is ",row);
    const docRef = this.afs.doc('leads/'+row.phone);
    docRef.update({status : row.status});
    const deadColref = this.afs.collection('dead');
    docRef.get().subscribe((doc) => {
      console.log("Document retrieved. ", doc.data());
      const leadData = doc.data();
      let copyData = {
        name: leadData['name'],
        phone: leadData['phone'],
        email: leadData['email'],
        notes: leadData['notes'],
        agent: leadData['agent'],
        sourceType: leadData['sourceType'],
        status: leadData['status'],
        markedAt: new Date(),
        reason: reason

      };


      deadColref.doc(row.phone.toString()).set(copyData).then(()=>{
        console.log("Data has been copied to dead collection");
        docRef.delete().then(()=> {console.log("Dead lead has been deleted");});
      });
    });
  }

  markConverted(row, reason){

    console.log("In function mark converted.");
    console.log("Value of the row is ",row);
    const docRef = this.afs.doc('leads/'+row.phone);
    docRef.update({status : row.status});
    const convertedColref = this.afs.collection('converted');
    docRef.get().subscribe((doc) => {
      console.log("Document retrieved. ", doc.data());
      const leadData = doc.data();
      let copyData = {
        name: leadData['name'],
        phone: leadData['phone'],
        email: leadData['email'],
        notes: leadData['notes'],
        agent: leadData['agent'],
        sourceType: leadData['sourceType'],
        status: leadData['status'],
        reason: reason,
        markedAt: new Date()
      };


      convertedColref.doc(row.phone.toString()).set(copyData).then(()=>{
        console.log("Data has been copied to converted collection");
        docRef.delete().then(()=> {console.log("Converted lead has been deleted");});
      });
    });
  }

  reassignAgent(row, selAgent){
    const docRef = this.afs.doc('leads/'+row.phone);
    docRef.update({
      agent: selAgent
    }).then(()=>{console.log("Agent was updated.")}).catch(()=>{console.log("Agent could not be updated.")});
  }

  statusUpdate(row: SalesTableItem){
    const docRef = this.afs.doc('leads/'+row.phone);
    docRef.update({status : row.status});
  //  docRef.update({ : row.comment});
  }

  noteUpdate(row: SalesTableItem){
    const docRef = this.afs.doc('leads/'+row.phone);
    docRef.update({notes : row.notes});
  }

  selectAgent(agent){
    this.currentSub.unsubscribe();
    this.leadsCollection = this.afs.collection('leads', ref => ref.where("agent.email", "==", agent.email));
    this.currentObs = this.leadsCollection.valueChanges();
    this.currentSub = this.currentObs.subscribe((snapshot) => {
      console.log("The observable has been triggered. snapshot is ", snapshot);
      let temp: SalesTableItem[] = [];
      snapshot.map((row)=> {
        temp.push({
        'name': row.name,
        'email' : row.email,
        'phone': row.phone,
        'location': row.locations,
        'notes': row.notes,
        'agent': {'name': row.agent.name , 'email': row.agent.email},
        'updatedAt': row.updatedAt.toDate(),
        'status': row.status
      })});
      this.dataObs.next(temp);
    });
  }

  addNewLead(lead){
    this.leadsCollection = this.afs.collection('leads');
    if(lead['phone'] === undefined){
      console.log("Number is needed");
      return;
    }
    //const tStamp = firebase.firestore.FieldValue.serverTimestamp();
    let newData = {
      name: (lead['name'] === undefined ? '' : lead['name'].toString()),
      phone: lead['phone'],
      email: (lead['email'] === undefined ? '' : lead['email'].toString()),
      notes: (lead['notes'] === undefined ? '' : lead['notes'].toString()) + '| Offline lead',
      agent: {email: '', name: ''},
      status: 'unassigned',
      sourceType: (lead['source'] === undefined ? '' : lead['source'].toString())
    };

    console.log("Adding new lead :", newData);

    this.leadsCollection.doc(newData.phone.toString()).set(newData).then(()=>{
      console.log("New Lead has been added");
      return;
    });

  }
}

// export interface SalesTableItem {
//   name: string;
//   email: string;
//   phone: string;
//   location: string[];
//   agent: object;
//   updatedAt: Date;
// }
